import React, { useEffect, useState } from 'react'
import { Button, Input, message, Popconfirm, Segmented, Select, Table, Tooltip,Form, Modal } from 'antd'
import './style.css'
import axios from 'axios'
import { SERVER_ADDRESS } from '../../Config/Config'
import { EditOutlined, EyeOutlined, SearchOutlined } from '@ant-design/icons'
import { PiTrashDuotone } from 'react-icons/pi'
import { GrPowerReset } from "react-icons/gr";

const ViewCoutnry = () => {
  const [selectedOption,setSelectedOption] = useState('Country')
  const [searchTerm,setSearchTerm] = useState('');
  const [countrySearchTerm,setCountrySearchTerm] = useState('');
  const [citysearchTerm,setCitySearchTerm] = useState('');
  const [data,setData] = useState([])
  const [filteredData, setFilteredData] = useState([]);
  const [loading,setLoading] = useState(false);
  const [country,setCountry] = useState([])
  const [state,setState] = useState([])
  const options = ['Country','State','City']
  const [selectedCountryId, setSelectedCountryId] = useState(null);
  const [selectedStateId,setSelectedStateId] = useState(null)
  const [countryModal,setCountryModal] = useState(false)
  const [stateModal,setStateModal] = useState(false)
  const [cityModal,setCityModal] = useState(false)
  const [countryForm] = Form.useForm();
  const [stateForm] = Form.useForm();
  const [cityForm] = Form.useForm();
  const [countryRow,setCountryRow] = useState(null)
  const [stateRow,setStateRow] = useState(null)
  const [cityRow,setCityRow] = useState(null)
  const userData = JSON.parse(atob(localStorage.getItem('token').split('.')[1]));
  const userPermission = userData.privelege || []

  useEffect(()=>{
    setLoading(true)
    fetchCountry();
    fetchData(selectedOption)
  },[selectedOption])

  const handleCloseCountryModal = ()=>{
    setCountryModal(false)
    countryForm.resetFields();
  }

  const handleCloseStateModal = ()=>{
    setStateModal(false)
    stateForm.resetFields();
  }

  const handleCloseCityModal = ()=>{
    setCityModal(false)
    cityForm.resetFields();
  }

  const handleCountryEdit = (record)=>{
    setCountryRow(record)
    countryForm.setFieldsValue({['country']:record['country'],['code']:record['code']})
    setCountryModal(true)
  }

  const handleStateEdit = (record)=>{
    setStateRow(record)
    stateForm.setFieldsValue({['country_id']:record['country_id'],['state']:record['state']})
    setStateModal(true)
  }

  const handleCityEdit =async (record)=>{
    setCityRow(record)
    const selectedCountry = country.find(item => item.value === record.country_id);
    await fetchState(record.country_id);
    cityForm.setFieldsValue({
      country_id: selectedCountry ? selectedCountry.value : null,
      state_id: record.state_id, // Now the correct states should be loaded
      city: record.city,
      lati:record.latitude,
      longi:record.longitude,
    });
    setCityModal(true)
  }

  const handleCountryUpdate = async(values)=>{
    const payload = {
      flag:1,
      id:countryRow.id,
      country:values.country
    }
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/editCountry`,payload)
      if(response.status === 200 && response.data.result === 1){
        const updatedData = filteredData.map(item =>
          item.id === countryRow.id ? { ...item, country: values.country } : item
        );
        setFilteredData(updatedData)
        message.success({content:`${response.data.message}`})
        setCountryModal(false);
      }
    } catch (error) {
      message.error({content:"Something Went Wrong !"})
    }
  }

  const handleStateUpdate = async(values)=>{
    const payload = {
      flag:2,
      id:stateRow.id,
      country_id:values.country_id,
      state:values.state,
    }
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/editCountry`,payload)
      if(response.status === 200 && response.data.result === 1){
        const selectedCountry = country.find(item => item.value === values.country_id);
        const updatedData = filteredData.map(item =>
          item.id === stateRow.id ? { ...item, country: selectedCountry ? selectedCountry.label : "", state:payload.state } : item
        );
        setFilteredData(updatedData)
        message.success({content:`${response.data.message}`})
        setStateModal(false);
      }
    } catch (error) {
      message.error({content:"Something Went Wrong !"})
    }
  }

  const handleCityUpdate = async(values)=>{
    const payload = {
      flag:3,
      id:cityRow.id,
      country_id:values.country_id,
      state_id:values.state_id,
      city:values.city,
    }
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/editCountry`,payload)
      if(response.status === 200 && response.data.result === 1){
        const selectedCountry = country.find(item => item.value === values.country_id);
        const selectedState = state.find(item => item.value === values.state_id);
        const updatedData = filteredData.map(item =>
          item.id === cityRow.id ? { ...item, country: selectedCountry ? selectedCountry.label : "",state:selectedState ? selectedState.label : "", city:payload.city } : item
        );
        setFilteredData(updatedData)
        message.success({content:`${response.data.message}`})
        setCityModal(false);
      }
    } catch (error) {
      message.error({content:"Something Went Wrong !"})
    }
  }

  const deleteCountryDatas = async(flag,id)=>{
    try {
      const response  = await axios.post(`${SERVER_ADDRESS}/api/deleteCountry`,{flag,id})
      if(response.status === 200 && response.data.result === 1 ){
        const updatedData = filteredData.filter(item=>item.id !== id)
        setFilteredData(updatedData)
        message.success({content:`${response.data.message}`})
      }
    } catch (error) {
      message.error({content:"Something went wrong !"})
    }
  }

  const fetchCountry = async()=>{
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/fetchCountry`,{type:1})
      if(response.status === 200 && response.data.result === 1){
        const options = response.data.data.map((item)=>({
          label:item.country,
          value:item.id
        }))
        setCountry(options)
      }
      else{
        message.error({content:"Something went Wrong"})
      }
    } catch (error) {
      message.error({content:"Something went Wrong"})
    }
  }


  const fetchData = async(key)=>{
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/fetchCountry`,{key})
      if(response.status === 200){
        if(response.data.result===1){
            setData(response.data.data)
            setFilteredData(response.data.data);
            setLoading(false)
        }
    }
    } catch (error) {
      message.error({content:"Something Went Wrong !"})
    }
  }

  const country_columns = [
    {
      title:"Id",
      dataIndex:"id",
      key:"id",
      sorter:(a,b)=>a.id - b.id
    },
    {
      title:"Country",
      dataIndex:"country",
      key:"country"
    },
    {
      title:"Country Code",
      dataIndex:"code",
      key:"code"
    },
    {
      title:"Options",
      key:"options",
      render:(_,record)=>(
        <div className='d-flex flex-row gap-2' >
          {userPermission.includes('edit') && (
            <Tooltip title='Edit' >
            <Button onClick={()=>{handleCountryEdit(record)}} variant='filled' color='blue' >
              <EditOutlined />
            </Button>
          </Tooltip>
          ) }
          {userPermission.includes('delete') && (
            <Tooltip title='Delete' >
            <Popconfirm title='Are You sure want to delete ?' >
              <Button onClick={()=>{deleteCountryDatas(1,record.id)}} variant='filled' color='danger' >
                <PiTrashDuotone />
              </Button>
            </Popconfirm>
          </Tooltip>
          ) }
        </div>
      )
    }
  ]

  const state_columns = [
    {
      title:"Id",
      dataIndex:"id",
      key:"id",
      sorter:(a,b)=>a.id - b.id
    },
    {
      title:"Country",
      dataIndex:"country",
      key:"country"
    },
    {
      title:"State",
      dataIndex:"state",
      key:"state"
    },
    {
      title:"Options",
      key:"options",
      render:(_,record)=>(
        <div className='d-flex flex-row gap-2' >
          {userPermission.includes("edit") && (
            <Tooltip title='Edit' >
            <Button onClick={()=>handleStateEdit(record)} variant='filled' color='blue' >
              <EditOutlined />
            </Button>
          </Tooltip>
          )}
          {userPermission.includes("delete") && (
            <Tooltip title='Delete' >
            <Popconfirm title='Are You sure want to delete ?' >
              <Button variant='filled' color='danger' >
                <PiTrashDuotone />
              </Button>
            </Popconfirm>
          </Tooltip>
          ) }
        </div>
      )
    }
  ]

  const city_columns = [
    {
      title:"Id",
      dataIndex:"id",
      key:"id",
      sorter:(a,b)=>a.id - b.id
    },
    {
      title:"Country",
      dataIndex:"country",
      key:"country"
    },
    {
      title:"State",
      dataIndex:"state",
      key:"state"
    },
    {
      title:"City",
      dataIndex:"city",
      key:"city"
    },
    {
      title:"Options",
      key:"options",
      render:(_,record)=>(
        <div className='d-flex flex-row gap-2' >
          {userPermission.includes('edit') && (
            <Tooltip title='Edit' >
            <Button variant='filled' onClick={()=>handleCityEdit(record)}  color='blue' >
              <EditOutlined />
            </Button>
            </Tooltip>
          ) }
          {userPermission.includes('delete') && (
            <Tooltip title='Delete' >
            <Popconfirm title='Are You sure want to delete ?' >
              <Button variant='filled' color='danger' >
                <PiTrashDuotone />
              </Button>
            </Popconfirm>
          </Tooltip>
          ) }
        </div>
      )
    }
  ]

  const fetchState = async(country_id)=>{
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/fetchCountry`,{type:2,country_id})
      if(response.status === 200 && response.data.result === 1){
        const options = response.data.data.map((item)=>({
          label:item.state,
          value:item.id
        }))
        setState(options)
      }
    } catch (error) {
      console.log(error)
      message.error({content:"Something went wrong"})
    }
  }
  const handlecitycountryChange = (value)=>{
    setSelectedCountryId(value)
    fetchState(value)
    handleFilters({countryId:value})
  }

  const handleCityChange = (value)=>{
    setSelectedStateId(value)
    handleFilters({stateId:value})
  }
  
  const handleFilters = ({countrySearch=countrySearchTerm, citySearch = citysearchTerm,search = searchTerm, countryId = selectedCountryId,stateId=selectedStateId }) => {
    setSearchTerm(search);
    setCitySearchTerm(citySearch)
    setCountrySearchTerm(countrySearch)
    setSelectedCountryId(countryId);
    setSelectedStateId(stateId)
    let filtered = data;

    if (search) {
      filtered = filtered.filter(item => 
        item.state.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (citySearch) {
      
      filtered = filtered.filter(item => 
        item.city.toLowerCase().includes(citySearch.toLowerCase())
      );
    }

    if (countrySearch) {
      
      filtered = filtered.filter(item => 
        item.country.toLowerCase().includes(countrySearch.toLowerCase())
      );
    }

    if (countryId) {
      filtered = filtered.filter(item => item.country_id === countryId);
    }

    if (stateId) {
      filtered = filtered.filter(item => item.state_id === stateId);
    }

    setFilteredData(filtered);
  };

  const resetFilters = () => {
    setSearchTerm('');
    setCitySearchTerm('');
    setCountrySearchTerm('');
    setSelectedCountryId(null);
    setSelectedStateId(null);
    setFilteredData(data); // Reset to original data
  };

  const renderTable = ()=>{
    switch (selectedOption) {
      case 'Country':
        return (
          <div>
            <div style={{marginTop:"1rem"}} >
            <Input 
                placeholder='Search by state name' 
                value={countrySearchTerm} 
                onChange={(e) => handleFilters({ countrySearch: e.target.value })} 
                style={{ width: "15rem" }} 
                prefix={<SearchOutlined />} 
              />
            </div>
            <Table style={{marginTop:"1rem"}} loading={loading} columns={country_columns} dataSource={filteredData} rowKey={'id'} />
          </div>
        )
      case 'State':
        return(
          <div>
            <div className='d-flex flex-row gap-3'>
              <Input 
                placeholder='Search by state name' 
                value={searchTerm} 
                onChange={(e) => handleFilters({ search: e.target.value })} 
                style={{ width: "15rem" }} 
                prefix={<SearchOutlined />} 
              />
              <Select
                showSearch
                style={{ width: '20rem' }}
                value={selectedCountryId}
                placeholder="Select a Country"
                options={country}
                onChange={(value) => handleFilters({ countryId: value })}
                optionFilterProp="label"
                filterSort={(a, b) => (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}
              />
              <Tooltip title='Reset Filter' >
                <Button onClick={()=>{resetFilters()}} variant='filled' color='cyan' >
                  <GrPowerReset />
                </Button>
              </Tooltip>
            </div>
          <Table style={{ marginTop: "1rem" }} loading={loading} columns={state_columns} dataSource={filteredData} rowKey={'id'} />
        </div>

        )
      case 'City':
        return (
          <div>
            <div className='d-flex flex-row gap-3'>
              <Input 
                placeholder='Search by city name' 
                value={citysearchTerm} 
                onChange={(e) => handleFilters({ citySearch: e.target.value })} 
                style={{ width: "15rem" }} 
                prefix={<SearchOutlined />} 
              />
              <Select 
                showSearch
                style={{ width: '20rem' }}
                value={selectedCountryId}
                placeholder="Select a Country"
                options={country}
                onChange={(value)=>handlecitycountryChange(value)}
                optionFilterProp="label"
                filterSort={(a, b) => (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}
              />
              <Select 
                showSearch
                value={selectedStateId}
                style={{ width: '20rem' }}
                placeholder="Select a State"
                options={state}
                onChange={(value)=>handleCityChange(value)}
                optionFilterProp="label"
                filterSort={(a, b) => (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}
              />
              <Tooltip title='Reset Filter' >
                <Button onClick={()=>{resetFilters()}} variant='filled' color='cyan' >
                  <GrPowerReset />
                </Button>
              </Tooltip>
            </div>
            <Table style={{marginTop:"1rem"}} loading={loading} columns={city_columns} dataSource={filteredData} rowKey={'id'} />
          </div>
        )
      default:
        break;
    }
  }

  return (
    <div style={{marginTop:'4rem'}} >
      <Segmented selected={selectedOption} onChange={setSelectedOption} options={options} block />
      <div style={{marginTop:'2rem'}} >
        {renderTable()}
      </div>
      <Modal width={'50%'} title={`Edit ${selectedOption}`} open={countryModal} onCancel={handleCloseCountryModal} footer={false} >
        <Form onFinish={handleCountryUpdate} form={countryForm} >
          <Form.Item label='Country' name='country' rules={[{required:true,message:"Enter Country name"}]} >
            <Input placeholder='Enter Country name' />
          </Form.Item>
          <Form.Item label='Code' name='code' rules={[{required:true,message:"Enter Country Code"},{len:3,message:"Maximum 3 characters should allowed"}]} >
            <Input placeholder='Enter Country name' />
          </Form.Item>
          <Form.Item wrapperCol={{offset:10}}  >
            <Button type='primary' htmlType = 'submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal width={'50%'} title={`Edit ${selectedOption}`} open={stateModal} onCancel={handleCloseStateModal} footer={false} >
        <Form onFinish={handleStateUpdate} form={stateForm} >
          <Form.Item label='Country' name='country_id' rules={[{required:true,message:"Select Country"}]} >
            <Select showSearch
                placeholder="Select a Country"
                options={country}
                optionFilterProp="label"
                filterSort={(a, b) => (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}/>
          </Form.Item>
          <Form.Item label='State' name='state' rules={[{required:true,message:"Enter Country name"}]} >
            <Input placeholder='Enter Country name' />
          </Form.Item>
          <Form.Item wrapperCol={{offset:10}}  >
            <Button type='primary' htmlType = 'submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal width={'50%'} title={`Edit ${selectedOption}`} open={cityModal} onCancel={handleCloseCityModal} footer={false} >
        <Form form={cityForm} onFinish={handleCityUpdate} >
          <Form.Item label='Country' name='country_id' rules={[{required:true,message:"Select Country"}]} >
            <Select showSearch
                placeholder="Select a Country"
                options={country}
                onChange={(value)=>handlecitycountryChange(value)}
                optionFilterProp="label"
                filterSort={(a, b) => (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}/>
          </Form.Item>
          <Form.Item label='State' name='state_id' rules={[{required:true,message:"Select State"}]} >
            <Select showSearch
                placeholder="Select a State"
                options={state}
                optionFilterProp="label"
                filterSort={(a, b) => (a?.label ?? '').toLowerCase().localeCompare((b?.label ?? '').toLowerCase())}/>
          </Form.Item>
          <Form.Item label='City' name='city' rules={[{required:true,message:"Enter city name"}]} >
            <Input placeholder='Enter Country name' />
          </Form.Item>
          <Form.Item label='Latitude' name='lati' rules={[{required:true,message:"Enter Latitude"},{ pattern: /^-?\d+(\.\d+)?$/, message: 'Please enter a valid latitide' }]} >
            <Input placeholder='Enter Latitude' />
          </Form.Item>
          <Form.Item label='Longitude' name='longi' rules={[{required:true,message:"Enter Longitude"},{ pattern: /^-?\d+(\.\d+)?$/, message: 'Please enter a valid longitude' }]} >
            <Input placeholder='Enter Longitude' />
          </Form.Item>
          <Form.Item wrapperCol={{offset:10}}  >
            <Button type='primary' htmlType = 'submit' >
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

export default ViewCoutnry